import { gql } from '@apollo/client';

export const CREATE_CHECKLIST_MUTATION = gql`
  mutation createChecklist(
    $checklistSections: [ChecklistSectionInputObject!]!
    $clientSpecific: Boolean!
    $companyId: Int
    $customPanelId: Int
    $defaultResultFamilyId: Int!
    $effectiveDate: DateTime
    $name: String!
    $serviceSchemeId: Int
    $showToFactoryUser: Boolean!
    $displayCustomPanel: String
    $hasLegalRequirements: Boolean!
    $hasRecommendations: Boolean!
  ) {
    createChecklist(
      checklistSections: $checklistSections
      clientSpecific: $clientSpecific
      companyId: $companyId
      customPanelId: $customPanelId
      defaultResultFamilyId: $defaultResultFamilyId
      effectiveDate: $effectiveDate
      name: $name
      serviceSchemeId: $serviceSchemeId
      showToFactoryUser: $showToFactoryUser
      displayCustomPanel: $displayCustomPanel
      hasLegalRequirements: $hasLegalRequirements
      hasRecommendations: $hasRecommendations
    ) {
      checklist {
        id
        currentVersion {
          id
          checklistSections {
            id
            checklistSectionIdAlias
            name
            isQuickActive
            quickResultId 
            parentPosition
            position
            questions {
              id
              checklistQuestionId
              position
            }
          }
          clientSpecific
          companyId
          createdById
          customPanelId
          defaultResultFamilyId
          effectiveDate
          name
          serviceSchemeId
          showToFactoryUser
          status
          updatedById
          version
          displayCustomPanel
          hasLegalRequirements
          hasRecommendations
        }
      }
    }
  }
`;

export const ADD_CHECKLIST_VERSION_MUTATION = gql`
  mutation addVersionToChecklist(
    $checklistId: Int!
    $checklistSections: [ChecklistSectionInputObject!]!
    $clientSpecific: Boolean!
    $companyId: Int
    $customPanelId: Int
    $defaultResultFamilyId: Int!
    $effectiveDate: DateTime
    $name: String!
    $oldEffectiveDate: DateTime
    $publish: Boolean
    $serviceSchemeId: Int
    $showToFactoryUser: Boolean!
    $displayCustomPanel: String
    $hasLegalRequirements: Boolean
    $hasRecommendations: Boolean
  ) {
    addVersionToChecklist(
      checklistId: $checklistId
      checklistSections: $checklistSections
      clientSpecific: $clientSpecific
      companyId: $companyId
      customPanelId: $customPanelId
      defaultResultFamilyId: $defaultResultFamilyId
      effectiveDate: $effectiveDate
      name: $name
      oldEffectiveDate: $oldEffectiveDate
      publish: $publish
      serviceSchemeId: $serviceSchemeId
      showToFactoryUser: $showToFactoryUser
      displayCustomPanel: $displayCustomPanel
      hasLegalRequirements: $hasLegalRequirements
      hasRecommendations: $hasRecommendations
    ) {
      checklistVersion {
        id
        checklistSections {
          id
          checklistSectionIdAlias
          name
          isQuickActive
          quickResultId 
          parentPosition
          position
          questions {
            id
            checklistQuestionId
            checklistQuestionIdAlias
            position
            resultFamilyId
          }
        }
        clientSpecific
        companyId
        createdById
        customPanelId
        defaultResultFamilyId
        effectiveDate
        name
        serviceSchemeId
        showToFactoryUser
        status
        updatedById
        version
        displayCustomPanel
        hasLegalRequirements
        hasRecommendations
      }
    }
  }
`;

export const EDIT_CHECKLIST_VERSION_MUTATION = gql`
  mutation editDraftChecklistVersion(
    $checklistId: Int!
    $checklistSections: [ChecklistSectionInputObject!]!
    $clientSpecific: Boolean!
    $companyId: Int
    $customPanelId: Int
    $defaultResultFamilyId: Int!
    $effectiveDate: DateTime
    $name: String!
    $publish: Boolean
    $serviceSchemeId: Int
    $showToFactoryUser: Boolean!
    $displayCustomPanel: String
    $hasLegalRequirements: Boolean
    $hasRecommendations: Boolean
  ) {
    editDraftChecklistVersion(
      checklistId: $checklistId
      checklistSections: $checklistSections
      clientSpecific: $clientSpecific
      companyId: $companyId
      customPanelId: $customPanelId
      defaultResultFamilyId: $defaultResultFamilyId
      effectiveDate: $effectiveDate
      name: $name
      publish: $publish
      serviceSchemeId: $serviceSchemeId
      showToFactoryUser: $showToFactoryUser
      displayCustomPanel: $displayCustomPanel
      hasLegalRequirements: $hasLegalRequirements
      hasRecommendations: $hasRecommendations
    ) {
      checklistVersion {
        id
        checklistId
        checklistSections {
          id
          checklistSectionIdAlias
          name
          isQuickActive
          quickResultId 
          parentPosition
          position
          questions {
            id
            checklistQuestionId
            position
          }
        }
        clientSpecific
        companyId
        createdById
        customPanelId
        defaultResultFamilyId
        effectiveDate
        name
        serviceSchemeId
        showToFactoryUser
        status
        updatedById
        version
        displayCustomPanel
        hasLegalRequirements
        hasRecommendations
      }
    }
  }

`
export const HTML_TO_PDF = gql`
  mutation htmlToPdf(
    $html: String!
  ) {
    htmlToPdf(
      html: $html
    ) {
      pdfBase64
    }
  }

`;
